<ion-toolbar mode="ios">
	<ion-buttons slot="start">
		<ion-button class="arrow-button left" fill="outline" (click)="back.emit()">
			<ion-icon slot="start" name="chevron-back-outline"></ion-icon>
			{{ 'SHARED_TEXT.BACK' | translate }}
		</ion-button>
	</ion-buttons>
	<ion-title class="ion-text-wrap">{{ title }}</ion-title>

	<ion-buttons slot="end">
		<ion-button *ngIf="!hideRightBtn" [disabled]="disableRightBtn" class="arrow-button right" (click)="continue.emit()">
			<ion-icon slot="end" name="chevron-forward-outline"></ion-icon>
			{{ 'SHARED_TEXT.CONTINUE' | translate }}
		</ion-button>
	</ion-buttons>
</ion-toolbar>
